/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

export default [[["ທ່ຽງຄືນ","ຕອນທ່ຽງ","ຕອນເຊົ້າ","ຕອນທ່ຽງ","ຕອນແລງ","ກາງຄືນ"],["ທ່ຽງຄືນ","ຕອນທ່ຽງ","ຕອນເຊົ້າ","ຕອນບ່າຍ","ຕອນແລງ","ກາງຄືນ"],["ທ່ຽງຄືນ","ຕອນທ່ຽງ","ຕອນເຊົ້າ","ຕອນບ່າຍ","ຕອນແລງ","ຕອນກາງຄືນ"]],[["ທ່ຽງ​ຄືນ","ທ່ຽງ","​ເຊົ້າ","ສ","ແລງ","​ກາງ​ຄືນ"],["ທ່ຽງ​ຄືນ","ທ່ຽງ","​ເຊົ້າ","ສວາຍ","ແລງ","​ກາງ​ຄືນ"],["ທ່ຽງຄືນ","ຕອນທ່ຽງ","​ເຊົ້າ","ສວາຍ","ແລງ","​ກາງ​ຄືນ"]],["00:00","12:00",["05:00","12:00"],["12:00","16:00"],["16:00","20:00"],["20:00","05:00"]]];
